/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import { List, UserSitePermission } from "./data-contracts";

/**
 * No description
 * @tags site-users
 * @name ListPermissionsAggregateInSite
 * @summary List all sites users permissions
 * @request GET:/orgs/{organizationId}/sites/{siteId}/permissions/aggregate
 * @secure
 */

// @ts-ignore
export const listPermissionsAggregateInSite: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: UserSitePermission[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/permissions/aggregate",
  method: "get",
  streaming: false,
  tags: ["site-users"],
  criticalityLevel: "low",
  deprecated: false,
};
